import { resourcePermission } from '@/permissions';

/**
 * Resource-specific permissions for the two non-quote sales-document masks.
 * The backend exposes independent catalogs for quotes, orders, and invoices;
 * sharing `sales_quotes.*` in the UI would make the client disagree with the
 * authorization enforced by the corresponding REST controllers.
 *
 * `share` sets the per-record levels of one document (BLP/nx#1771). Master
 * decides it on the document itself, so the header button asks the backend for
 * the record (`useRecordPermissions`) rather than this type-level key.
 */
export const SALES_ORDER_PERMISSIONS = {
  read: resourcePermission('/sales_orders', 'read'),
  create: resourcePermission('/sales_orders', 'create'),
  update: resourcePermission('/sales_orders', 'update'),
  delete: resourcePermission('/sales_orders', 'delete'),
  share: resourcePermission('/sales_orders', 'share'),
} as const;

export const SALES_INVOICE_PERMISSIONS = {
  read: resourcePermission('/sales_invoices', 'read'),
  create: resourcePermission('/sales_invoices', 'create'),
  update: resourcePermission('/sales_invoices', 'update'),
  delete: resourcePermission('/sales_invoices', 'delete'),
  share: resourcePermission('/sales_invoices', 'share'),
} as const;
